import { UseMutationOptions, useQueryClient } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  SwitchTeamMutation,
  SwitchTeamMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { APP_TOKEN_QUERY_KEY } from "../useAppToken";
import { useGraphQlMutation } from "../useGraphQlClient";
import { CURRENT_USER_QUERY_KEY } from "../users/useCurrentUser";

const switchTeamMutation = graphql(`
  mutation switchTeam($input: SwitchTeamInput!) {
    switchTeam(input: $input) {
      teamId
    }
  }
`);

/**
 * Hook used to switch teams for the current user. User can only switch to a team within their current company
 * @param options
 * @returns
 */
export function useSwitchTeam(
  options?: UseMutationOptions<SwitchTeamMutation, unknown, SwitchTeamMutationVariables, unknown>,
) {
  const queryClient = useQueryClient();
  return useGraphQlMutation(switchTeamMutation, {
    ...options,
    onSuccess: (data, variables, context) => {
      // The app token carries the user's team, so mint a new one.
      void queryClient.invalidateQueries({ queryKey: APP_TOKEN_QUERY_KEY });
      void queryClient.invalidateQueries({ queryKey: CURRENT_USER_QUERY_KEY });
      void queryClient.invalidateQueries({ queryKey: ["teams"] });
      void queryClient.invalidateQueries({ queryKey: ["team_management_users"] });

      options?.onSuccess?.(data, variables, context);
    },
  });
}
